(function () {
  const GAP = 12; 

  function absTop(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  function jumpToTab(tabId) {
    const tab = document.getElementById(tabId);
    if (!tab) return;

    const prefersReduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const y = Math.max(0, absTop(tab) - GAP);

    window.scrollTo({
      top: y,
      behavior: prefersReduce ? "auto" : "smooth",
    });
  }

  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest(".tabgoa[data-target]");
      if (!btn) return;

      e.preventDefault();
      const id = btn.getAttribute("data-target");
      if (id) jumpToTab(id);
    },
    { passive: false }
  );
})();
